import { render, staticRenderFns } from "./ModalCustomerComponent.vue?vue&type=template&id=091c8284"
import script from "./ModalCustomerComponent.vue?vue&type=script&lang=js"
export * from "./ModalCustomerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports